import "./markup-menu";
import $ from 'jquery';

global.$ = global.jQuery = $;
import '@fancyapps/fancybox';
import fullpage from 'fullpage.js';
import slick from 'slick-carousel';
import { main } from './components/main';
import scroll from './components/scroll';
import map from './components/map';
import {sliders} from './components/sliders';
import area from './components/area';
import {svg} from './components/svg';
import readmore from './components/readmore';
import svg4everybody from 'svg4everybody';
import mCustomScrollbar from 'malihu-custom-scrollbar-plugin';
import Tabs from './components/tabs';
import Select from './components/select';
import 'jquery.maskedinput/src/jquery.maskedinput';

require('jquery-mousewheel');
// require("jquery.fancybox/source/jquery.fancybox");

document.addEventListener("DOMContentLoaded", () => {
  scroll();
  readmore();
  sliders();
  main();
  area();
  svg();
  svg4everybody();
  global.customSelect = new Select();
  new Tabs();

  $('.select .select__list').mCustomScrollbar();
  $('.popup-lizing__text').mCustomScrollbar();
  $('.brands-top__text').mCustomScrollbar();
  $('.scrollable').mCustomScrollbar({
    advanced:{
      updateOnContentResize: true
    }
  });


  // $(window).on('load resize', () => {
  //   if ($(window).width() < '767') {
  //     $('.characteristics__inner').mCustomScrollbar({
  //       axis:"x"
  //     });
  //   } else {
  //     if (!$('.characteristics__inner').length) return;
  //     $('.characteristics__inner').mCustomScrollbar('destroy');
  //   }
  // });


  $("input[type='tel']").mask("+38 (999) 999-99-99");

  $("input[name='date_from']").mask("9999-99-99");
  $("input[name='date_to']").mask("9999-99-99");

  // $(".fancybox").fancybox();

  if (document.getElementById('map')) {
    map();
  }

  $('.select').on('click', function clickSelect() {
    if ($('.select').hasClass('select--open')) {
      $('.select').removeClass('select--open');
      $(this).toggleClass('select--open');
    }
  });

  // $(".fancybox").fancybox({
  //   beforeShow () {
  //     const imgAlt = $(this.element).find("img").attr("alt");
  //     const dataAlt = $(this.element).data("alt");
  //     if (imgAlt) {
  //       $(".fancybox-image").attr("alt", imgAlt);
  //     } else if (dataAlt) {
  //       $(".fancybox-image").attr("alt", dataAlt);
  //     }
  //   }
  // });
});



// WEBPACK FOOTER //
// app/scripts/index.js